var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { computed, onMounted, ref, watch } from "vue";
import localize from "@/utils/localization";
import UtcDate from "@/components/UtcDate.vue";
import Heading from "@/components/Common/Heading.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
import DelayedInput from "@/components/Common/DelayedInput.vue";
import StatelessTags from "@/components/TagsMultiselect/StatelessTags.vue";
import * as ArchiveServices from "@/stores/services/historyArchive.services";
import { reimportHistoryFromExportRecordAsync, } from "@/stores/services/historyArchive.services";
import { BAlert, BButton, BButtonGroup, BBadge, BPagination, BListGroup, BListGroupItem } from "bootstrap-vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faUndo, faCopy, faEye } from "@fortawesome/free-solid-svg-icons";
import { useRouter } from "vue-router/composables";
import { useHistoryStore } from "@/stores/historyStore";
import { useToast } from "@/composables/toast";
import { useConfirmDialog } from "@/composables/confirmDialog";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HistoryArchive',
    setup(__props) {
        const router = useRouter();
        const historyStore = useHistoryStore();
        const toast = useToast();
        const { confirm } = useConfirmDialog();
        const archivedHistories = ref([]);
        const isLoading = ref(true);
        const perPage = ref(10);
        const currentPage = ref(1);
        const totalRows = ref(0);
        const sortBy = ref("update_time");
        const sortDesc = ref(true);
        const searchText = ref("");
        const noResults = computed(() => totalRows.value === 0);
        const hasFilters = computed(() => searchText.value !== "");
        const noHistoriesMatchingFilter = computed(() => hasFilters.value && noResults.value);
        const showPagination = computed(() => totalRows.value > perPage.value && !isLoading.value && !noResults.value);
        library.add(faUndo, faCopy, faEye);
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            loadArchivedHistories();
        }));
        watch([searchText, currentPage, perPage, sortBy, sortDesc], () => {
            loadArchivedHistories();
        });
        function updateSearchQuery(query) {
            return __awaiter(this, void 0, void 0, function* () {
                searchText.value = query;
            });
        }
        function loadArchivedHistories() {
            return __awaiter(this, void 0, void 0, function* () {
                isLoading.value = true;
                const result = yield ArchiveServices.fetchArchivedHistories({
                    query: searchText.value,
                    currentPage: currentPage.value,
                    pageSize: perPage.value,
                    sortBy: sortBy.value,
                    sortDesc: sortDesc.value,
                });
                totalRows.value = result.totalMatches;
                archivedHistories.value = result.histories;
                isLoading.value = false;
            });
        }
        function canImportCopy(history) {
            var _a;
            return ((_a = history.export_record_data) === null || _a === void 0 ? void 0 : _a.target_uri) !== undefined;
        }
        function onViewHistoryInCenterPanel(history) {
            router.push(`/histories/view?id=${history.id}`);
        }
        function onRestoreHistory(history) {
            return __awaiter(this, void 0, void 0, function* () {
                const confirmTitle = localize(`Unarchive '${history.name}'?`);
                const confirmMessage = history.purged && history.export_record_data
                    ? localize("Are you sure you want to restore this (purged) history? Please note that this will not restore the datasets associated with this history. If you want to fully recover it, you can import a copy from the export record instead.")
                    : localize("Are you sure you want to restore this history? This will move the history back to your active histories.");
                const confirmed = yield confirm(confirmMessage, { title: confirmTitle });
                if (!confirmed) {
                    return;
                }
                try {
                    const force = true;
                    yield historyStore.unarchiveHistoryById(history.id, force);
                    toast.success(localize(`History '${history.name}' has been restored.`), localize("History Restored"));
                    return loadArchivedHistories();
                }
                catch (error) {
                    toast.error(localize(`Failed to restore history '${history.name}' with reason: ${error}`), localize("History Restore Failed"));
                }
            });
        }
        function onImportCopy(history) {
            return __awaiter(this, void 0, void 0, function* () {
                const confirmed = yield confirm(localize(`Are you sure you want to import a new copy of this history? This will create a new history with the same datasets contained in the associated export snapshot.`), {
                    title: localize(`Import Copy of '${history.name}'?`),
                });
                if (!confirmed) {
                    return;
                }
                try {
                    yield reimportHistoryFromExportRecordAsync(history);
                    toast.success(localize(`The History '${history.name}' it's being imported. This process may take a while. Check your histories list after a few minutes.`), localize("Importing History in background..."));
                }
                catch (error) {
                    toast.error(localize(`Failed to import history '${history.name}' with reason: ${error}`), localize("History Import Failed"));
                }
            });
        }
        return { __sfc: true, router, historyStore, toast, confirm, archivedHistories, isLoading, perPage, currentPage, totalRows, sortBy, sortDesc, searchText, noResults, hasFilters, noHistoriesMatchingFilter, showPagination, updateSearchQuery, loadArchivedHistories, canImportCopy, onViewHistoryInCenterPanel, onRestoreHistory, onImportCopy, localize, UtcDate, Heading, LoadingSpan, DelayedInput, StatelessTags, BAlert, BButton, BButtonGroup, BBadge, BPagination, BListGroup, BListGroupItem, FontAwesomeIcon };
    }
});
